/* Valedictorian acquisition v1. No email, name, full URL, or advertising IDs collected.
 * Shopify custom events require a separately configured destination subscriber.
 */
(() => {
  if (window.__vdGrowthLoaded || window.Shopify?.designMode) return;
  window.__vdGrowthLoaded = true;
  const KEY = 'vd-acquisition-v1', PENDING = 'vd-signup-pending-v1', TTL = 30 * 60 * 1000;
  const campaigns = ['issue008_acquisition', 'magazine_intro_boston_202609'];
  const creatives = ['beginner_idea_a', 'welcome_world_a', 'culture_breadth_a', 'signup_qa', 'carousel_c'];
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const allowed = () => {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true && window.Shopify.customerPrivacy.marketingAllowed() === true; }
    catch (_) { return false; }
  };
  const fresh = record => record && Number.isFinite(record.at) && Date.now() >= record.at && Date.now() - record.at < TTL;
  const preview = window.Shopify?.theme?.role !== 'main' || new URLSearchParams(location.search).has('preview_theme_id');
  let context = {}, initialized = false, completing = false;
  function capture() {
    const q = new URLSearchParams(location.search), saved = read(KEY);
    const source = q.get('utm_source'), medium = q.get('utm_medium'), campaign = q.get('utm_campaign'), content = q.get('utm_content');
    // Only our registered campaign vocabulary can enter storage or event payloads.
    if (['instagram', 'facebook', 'meta'].includes(source) && medium === 'paid_social' && campaigns.includes(campaign) && creatives.includes(content)) {
      context = { utm_source: source, utm_medium: medium, utm_campaign: campaign, utm_content: content };
      write(KEY, { at: Date.now(), context });
    } else if (fresh(saved)) {
      const c = saved.context || {};
      if (['instagram','facebook','meta'].includes(c.utm_source) && c.utm_medium === 'paid_social' && campaigns.includes(c.utm_campaign) && creatives.includes(c.utm_content)) context = { utm_source: c.utm_source, utm_medium: c.utm_medium, utm_campaign: c.utm_campaign, utm_content: c.utm_content };
    } else { remove(KEY); context = {}; }
  }
  function publish(name, data) {
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try {
      const result = window.Shopify.analytics.publish('valedictorian:' + name, { schema_version: 1, preview_mode: preview, ...data });
      // This is a handoff to Shopify, not proof of receipt in Meta or Google.
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return result !== false;
    } catch (_) { return false; }
  }
  function complete() {
    if (completing || !allowed()) return;
    const pending = read(PENDING);
    if (!fresh(pending) || !/^[0-9a-f-]{36}$/.test(pending.id || '') || typeof pending.form_id !== 'string') { remove(PENDING); return; }
    const form = document.getElementById(pending.form_id);
    if (!form || !form.closest('.vt-signup')) return;
    if (form.querySelector('[data-signup-error]')) { remove(PENDING); return; }
    if (!form.querySelector('[data-signup-success]')) return;
    completing = true;
    // Consume before handing off: reload/back/double activation cannot repeat it.
    remove(PENDING);
    publish('newsletter_signup', { ...context, signup_surface: 'welcome', event_id: pending.id, result: 'shopify_form_accepted' });
  }
  function initialize() {
    if (!allowed()) { context = {}; remove(KEY); remove(PENDING); return; }
    capture(); initialized = true; complete();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form?.matches('form') || !form.closest('.vt-signup') || !form.id) return;
    if (!initialized || !allowed() || event.defaultPrevented || !form.checkValidity()) return;
    try { if (localStorage.getItem('vd-newsletter-joined') === '1') return; } catch (_) {}
    const id = window.crypto?.randomUUID?.();
    if (!id) return;
    // A submission is pending only. No conversion is emitted at this point.
    write(PENDING, { id, at: Date.now(), form_id: form.id });
  }, true);
  document.addEventListener('valedictorian:threshold', event => {
    if (event.detail?.action === 'enter') publish('entry', { ...context, entry_surface: 'welcome', method: ['button','signup','anchor','spine','player','artifact','join'].includes(event.detail.method) ? event.detail.method : 'other' });
  });
  document.addEventListener('visitorConsentCollected', initialize);
  if (window.Shopify?.customerPrivacy) initialize();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) initialize(); });
})();
